@import "tailwindcss";
@import "tw-animate-css";
@import "shadcn/tailwind.css";
@import "@fontsource-variable/geist";

@custom-variant dark (&:is(.dark *));

@theme inline {
    --font-heading: var(--font-sans);
    --font-sans: 'Geist Variable', sans-serif;
    --color-sidebar-ring: var(--sidebar-ring);
    --color-sidebar-border: var(--sidebar-border);
    --color-sidebar-accent-foreground: var(--sidebar-accent-foreground);
    --color-sidebar-accent: var(--sidebar-accent);
    --color-sidebar-primary-foreground: var(--sidebar-primary-foreground);
    --color-sidebar-primary: var(--sidebar-primary);
    --color-sidebar-foreground: var(--sidebar-foreground);
    --color-sidebar: var(--sidebar);
    --color-chart-5: var(--chart-5);
    --color-chart-4: var(--chart-4);
    --color-chart-3: var(--chart-3);
    --color-chart-2: var(--chart-2);
    --color-chart-1: var(--chart-1);
    --color-ring: var(--ring);
    --color-input: var(--input);
    --color-border: var(--border);
    --color-destructive: var(--destructive);
    --color-accent-foreground: var(--accent-foreground);
    --color-accent: var(--accent);
    --color-muted-foreground: var(--muted-foreground);
    --color-muted: var(--muted);
    --color-secondary-foreground: var(--secondary-foreground);
    --color-secondary: var(--secondary);
    --color-primary-foreground: var(--primary-foreground);
    --color-primary: var(--primary);
    --color-popover-foreground: var(--popover-foreground);
    --color-popover: var(--popover);
    --color-card-foreground: var(--card-foreground);
    --color-card: var(--card);
    --color-foreground: var(--foreground);
    --color-background: var(--background);
    --radius-sm: calc(var(--radius) * 0.6);
    --radius-md: calc(var(--radius) * 0.8);
    --radius-lg: var(--radius);
    --radius-xl: calc(var(--radius) * 1.4);
    --radius-2xl: calc(var(--radius) * 1.8);
    --radius-3xl: calc(var(--radius) * 2.2);
    --radius-4xl: calc(var(--radius) * 2.6);
}

:root {
    --background: oklch(0.145 0 0);
    --foreground: oklch(0.93 0 0);
    --card: oklch(0.18 0 0);
    --card-foreground: oklch(0.93 0 0);
    --popover: oklch(0.18 0 0);
    --popover-foreground: oklch(0.93 0 0);
    --primary: oklch(0.55 0.18 275);
    --primary-foreground: oklch(0.98 0 0);
    --secondary: oklch(0.22 0 0);
    --secondary-foreground: oklch(0.93 0 0);
    --muted: oklch(0.22 0 0);
    --muted-foreground: oklch(0.62 0 0);
    --accent: oklch(0.22 0 0);
    --accent-foreground: oklch(0.93 0 0);
    --destructive: oklch(0.577 0.245 27.325);
    --border: oklch(1 0 0 / 8%);
    --input: oklch(1 0 0 / 12%);
    --ring: oklch(0.55 0.18 275);
    --chart-1: oklch(0.55 0.18 275);
    --chart-2: oklch(0.62 0.12 200);
    --chart-3: oklch(0.72 0.14 80);
    --chart-4: oklch(0.65 0.16 320);
    --chart-5: oklch(0.62 0.14 150);
    --radius: 0.5rem;
    --sidebar: oklch(0.17 0 0);
    --sidebar-foreground: oklch(0.93 0 0);
    --sidebar-primary: oklch(0.55 0.18 275);
    --sidebar-primary-foreground: oklch(0.98 0 0);
    --sidebar-accent: oklch(0.22 0 0);
    --sidebar-accent-foreground: oklch(0.93 0 0);
    --sidebar-border: oklch(1 0 0 / 8%);
    --sidebar-ring: oklch(0.55 0.18 275);
}

.dark {
    --background: oklch(0.12 0 0);
    --foreground: oklch(0.93 0 0);
    --card: oklch(0.17 0 0);
    --card-foreground: oklch(0.93 0 0);
    --popover: oklch(0.17 0 0);
    --popover-foreground: oklch(0.93 0 0);
    --primary: oklch(0.55 0.18 275);
    --primary-foreground: oklch(0.98 0 0);
    --secondary: oklch(0.22 0 0);
    --secondary-foreground: oklch(0.93 0 0);
    --muted: oklch(0.22 0 0);
    --muted-foreground: oklch(0.62 0 0);
    --accent: oklch(0.22 0 0);
    --accent-foreground: oklch(0.93 0 0);
    --destructive: oklch(0.704 0.191 22.216);
    --border: oklch(1 0 0 / 8%);
    --input: oklch(1 0 0 / 12%);
    --ring: oklch(0.55 0.18 275);
    --sidebar: oklch(0.15 0 0);
    --sidebar-foreground: oklch(0.93 0 0);
    --sidebar-primary: oklch(0.55 0.18 275);
    --sidebar-primary-foreground: oklch(0.98 0 0);
    --sidebar-accent: oklch(0.22 0 0);
    --sidebar-accent-foreground: oklch(0.93 0 0);
    --sidebar-border: oklch(1 0 0 / 8%);
    --sidebar-ring: oklch(0.55 0.18 275);
}

@layer base {
  * {
    @apply border-border outline-ring/50;
  }
  body {
    @apply bg-background text-foreground antialiased;
  }
  html {
    @apply font-sans;
  }
}
